// extracted by mini-css-extract-plugin
export default {"container":"my-ip_container__xYUwS","ip":"my-ip_ip__lftIt","alert":"my-ip_alert__2zzFa"};